import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Header } from './Header';

export const Layout: React.FC = () => {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
        >
          <Outlet />
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border-light dark:border-border-dark py-8 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
              © {new Date().getFullYear()} ParlayGround. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/terms"
                className="text-sm text-text-secondary-light dark:text-text-secondary-dark hover:text-primary transition-colors"
              >
                Terms of Service
              </Link>
              <Link
                to="/privacy"
                className="text-sm text-text-secondary-light dark:text-text-secondary-dark hover:text-primary transition-colors"
              >
                Privacy Policy
              </Link>
              <a
                href="mailto:support@parlayground.com"
                className="text-sm text-text-secondary-light dark:text-text-secondary-dark hover:text-primary transition-colors"
              >
                Support
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
